import React from "react";
import { Typography, TypographyProps } from "@mui/material";
import { SxProps, Theme } from "@mui/system";

interface EllipsisTextProps extends TypographyProps {
  sx?: SxProps<Theme>;
  className?: string;
  lines?: number;
}

const EllipsisText: React.FC<EllipsisTextProps> = ({
  children,
  sx = {},
  className = "",
  lines = 1,
  ...props
}) => {
  const ellipsisStyle =
    lines === 1
      ? {
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "block",
          maxWidth: "100%",
        }
      : {
          display: "-webkit-box",
          WebkitLineClamp: lines,
          WebkitBoxOrient: "vertical" as const,
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: "100%",
        };
  return (
    <Typography
      className={`cutoff-text${lines === 1 ? " oneline" : " twoline"} ${className}`}
      sx={{ ...ellipsisStyle, ...sx }}
      {...props}
    >
      {children}
    </Typography>
  );
};

export default EllipsisText; 